import { updateItemInCollection } from "directus/src/operations";

export async function updateTag({ item, tagId }) {
  try {
    const data = await updateItemInCollection("tags", tagId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
